import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Clock, MapPin, Phone } from 'lucide-react';

const InfoBar = () => {
  const { t } = useLanguage();

  const items = [
    {
      icon: Clock,
      title: t.info.hoursTitle,
      lines: [`${t.info.weekdays} 8–18`, `${t.info.weekend} — ${t.info.closed}`]
    },
    {
      icon: MapPin,
      title: t.info.locationTitle,
      lines: ['Kalustetie 1', '01720 Vantaa']
    },
    {
      icon: Phone,
      title: t.info.phoneTitle,
      lines: ['040 7611347']
    }
  ];

  return (
    <section id="info" className="bg-[#7A1F25] py-10">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-start gap-4 group">
            <div className="shrink-0 w-12 h-12 rounded-full border border-[#D4A94B]/40 bg-[#D4A94B]/10 flex items-center justify-center group-hover:bg-[#D4A94B]/20 transition-colors">
              <item.icon className="text-[#D4A94B]" size={20} />
            </div>
            <div>
              <h3 className="font-serif text-[#D4A94B] text-sm tracking-[0.2em] uppercase mb-1">{item.title}</h3>
              {item.lines.map((line, i) => (
                <p key={i} className="text-white/90 text-base leading-snug">{line}</p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfoBar;
